var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgPlusSquare = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M5,2.25 L19,2.25 C20.5187831,2.25 21.75,3.48121694 21.75,5 L21.75,19 C21.75,20.5187831 20.5187831,21.75 19,21.75 L5,21.75 C3.48121694,21.75 2.25,20.5187831 2.25,19 L2.25,5 C2.25,3.48121694 3.48121694,2.25 5,2.25 Z M5,3.75 C4.30964406,3.75 3.75,4.30964406 3.75,5 L3.75,19 C3.75,19.6903559 4.30964406,20.25 5,20.25 L19,20.25 C19.6903559,20.25 20.25,19.6903559 20.25,19 L20.25,5 C20.25,4.30964406 19.6903559,3.75 19,3.75 L5,3.75 Z M12.75,11.25 L16,11.25 C16.4142136,11.25 16.75,11.5857864 16.75,12 C16.75,12.4142136 16.4142136,12.75 16,12.75 L12.75,12.75 L12.75,16 C12.75,16.4142136 12.4142136,16.75 12,16.75 C11.5857864,16.75 11.25,16.4142136 11.25,16 L11.25,12.75 L8,12.75 C7.58578644,12.75 7.25,12.4142136 7.25,12 C7.25,11.5857864 7.58578644,11.25 8,11.25 L11.25,11.25 L11.25,8 C11.25,7.58578644 11.5857864,7.25 12,7.25 C12.4142136,7.25 12.75,7.58578644 12.75,8 L12.75,11.25 Z"
  }));
};
export default SvgPlusSquare;